import { store_cartjsObject, store_merchanturl, store_requestId, store_cashToPrepaid } from '../stores/CommonStore';
import { store_environment } from '../stores/LoginStore';
export let merchantUrl: string, env: string, cashToPrepaid: boolean;
store_merchanturl.subscribe((res) => {
  merchantUrl = res;
});
store_environment.subscribe((res) => {
  if (res) {
    env = res;
    if (res === 'local') {
      setCart();
      setReqId();
    }
  }
});
store_cashToPrepaid.subscribe((res) => {
  cashToPrepaid = res;
});

export const getHealthServiceBaseUrl = () => {
  let url = 'https://api-gw.gokwik.io/core-health';
  // @ts-ignore
  if (!env && window.merchantInfo?.environment !== 'production') {
    url = 'https://api-gw-v4.dev.gokwik.io/sandbox/core-health';
  }
  if (env === 'sandbox' || env === 'qa' || env === 'dev') {
    url = 'https://api-gw-v4.dev.gokwik.io/sandbox/core-health';
  } else if (env === 'production') {
    url = 'https://api-gw.gokwik.io/core-health';
  }
  return url;
};

export const getAddressSuggestionBaseUrl = () => {
  let url = 'https://api-gw-v4.dev.gokwik.io/sandbox';
  if (env === 'dev') {
    url = 'https://api-gw-v4.dev.gokwik.io/dev';
  } else if (env === 'qa') {
    url = 'https://api-gw-v4.dev.gokwik.io/qa';
  } else if (env === 'sandbox') {
    url = 'https://api-gw-v4.dev.gokwik.io/sandbox';
  } else if (env === 'production') {
    url = 'https://gkx.gokwik.co';
  }
  return url;
};

export const api_url = () => {
  let url;
  if (env === 'dev') {
    url = 'https://dev-core-api.dev.gokwik.in';
  } else if (env == 'qa-rto') {
    url = 'https://qa2-core-api.dev.gokwik.in';
  } else if (env == 'qaone') {
    url = 'https://qa1-core-api.dev.gokwik.in';
  } else if (env == 'sandbox') {
    url = 'https://sandbox.gokwik.co';
  } else if (env === 'production') {
    url = 'https://api.gokwik.co';
  } else if (env === 'qa') {
    url = 'https://qa-core-api.dev.gokwik.in';
  } else if (env === 'hdev') {
    url = 'https://api-gw-dev.dev.gokwik.io/dev/replica';
  } else if (env === 'ndev') {
    url = 'https://ndev.gokwik.co';
  } else if (env === 'local') {
    // url = 'http://localhost:3000';
    url = 'https://api.gokwik.co';

    // url = 'https://dev-core-api.dev.gokwik.in';
  } else if (env === 'qatwo') {
    url = 'https://api-gw-dev.dev.gokwik.io/qa/replica';
  } else if (env === 'dev-core') {
    url = 'https://dev-core-api.dev.gokwik.in';
  } else if (env === 'qa-core') {
    url = 'https://qa-core-api.dev.gokwik.in';
  } else if (env === 'sandbox-core') {
    url = 'https://sandbox-core-api.dev.gokwik.in';
  } else if (env === 'pci-prod') {
    url = 'https://prod-core-api.gokwik.co';
  } else if (env === 'idev') {
    url = 'https://idev.gokwik.co';
  }
  return url;
};

export const getCredUrl = (environment = '') => {
  const currEnv = environment ? environment : env;
  if (currEnv == 'production') {
    return 'https://cred.club/checkout/pay';
  } else {
    return 'https://cred-web-stg.dreamplug.in/checkout/pay';
  }
};

export const experiment_url = () => {
  let url;
  const devEnvironments = ['dev', 'hdev', 'ndev', 'idev'];
  if (devEnvironments.includes(env)) {
    url = 'https://api-gw-v4.dev.gokwik.io/dev';
  } else if (env === 'qa' || env === 'qatwo' || env === 'local') {
    url = 'https://api-gw-v4.dev.gokwik.io/qa';
  } else if (env === 'sandbox') {
    url = 'https://api-gw-v4.dev.gokwik.io/sandbox';
  } else if (env == 'production' || env === 'pci-prod') {
    url = 'https://api-gw.gokwik.io';
  } else {
    // need to add more envs here
    url = 'https://api-gw-dev.dev.gokwik.io/dev';
  }
  return url;
};

export const twidpay_api = () => {
  let url;
  const devEnvironments = ['dev', 'local', 'hdev', 'ndev', 'idev'];
  if (devEnvironments.includes(env)) {
    url = 'https://api-gw-dev.dev.gokwik.io/qa';
  } else if (env === 'qa' || env === 'qatwo') {
    url = 'https://api-gw-dev.dev.gokwik.io/qa';
  } else if (env === 'production') {
    url = 'https://gkx.gokwik.co';
  } else {
    url = `https://api-gw-dev.dev.gokwik.io/${env}`;
  }
  return url;
};

export const kp_api = () => {
  let url;
  if (env === 'sandbox' || env === 'local') {
    url = 'https://api-gw-v4.dev.gokwik.io/sandbox';
  } else if (env == 'production') {
    url = 'https://gkx.gokwik.co';
  }
  return url;
};

export const cdn_path = () => {
  return env === 'local'
    ? 'http://localhost:8080'
    : env === 'dev' || env === 'hdev' || env === 'ndev' || env === 'idev'
      ? 'https://dev.pdp.gokwik.co'
      : env === 'production'
        ? 'https://pdp.gokwik.co'
        : env === 'sandbox'
          ? 'https://sandbox.pdp.gokwik.co'
          : env === 'qa-rto'
            ? 'https://qa2.pdp.gokwik.co'
            : env === 'qaone'
              ? 'https://qa1.pdp.gokwik.co'
              : env === 'qatwo'
                ? 'https://qatwo.pdp.gokwik.co'
                : env === 'qa' && 'https://qa.pdp.gokwik.co';
};

export const analytics_api = (paramEnv?: string) => {
  let url = 'https://sandbox-analytics.dev.gokwik.io/api/v1/events';
  if (paramEnv) env = paramEnv;
  if (env === 'dev' || env === 'local' || env === 'hdev' || env === 'ndev' || env === 'idev') {
    url = 'https://dev-analytics.dev.gokwik.io/api/v1/events';
  } else if (env == 'sandbox') {
    url = 'https://sandbox-analytics.dev.gokwik.io/api/v1/events';
  } else if (env == 'production' || env === 'pci-prod') {
    url = 'https://hits.gokwik.co/api/v1/events';
  } else if (env == 'qa' || env == 'qa-rto' || env == 'qaone') {
    url = 'https://qa-analytics.dev.gokwik.io/api/v1/events';
  } else if (env == 'qatwo') {
    url = 'https://qa-analytics.dev.gokwik.io/api/v1/events';
  }
  return url;
};

export const analytics_api_v2 = () => {
  let url;
  if (env === 'dev' || env === 'local' || env === 'hdev' || env === 'ndev' || env === 'idev') {
    url = 'https://devhits.gokwik.co/api/v2/events';
  } else if (env == 'sandbox') {
    url = 'https://sandbox-hits.gokwik.co/api/v2/events';
  } else if (env == 'production' || env === 'pci-prod') {
    url = 'https://hits.gokwik.co/api/v2/events';
  } else if (env == 'qa') {
    url = 'https://qa-hits.gokwik.co/api/v2/events';
  } else if (env == 'qatwo') {
    url = 'https://qa-analytics.dev.gokwik.in/api/v2/events';
  }
  return url;
};

export const merchant_url = () => {
  return env === 'local' ? 'http://localhost:1010/' : merchantUrl;
};

export const merchant_url_api = () => {
  return env === 'local' ? 'https://gokwik-prod.myshopify.com' : merchantUrl;
};

export const XGokwikToken = () => {
  if (!env) env = window.merchantInfo?.environment;
  console.log(env);
  if (
    env === 'dev' ||
    env === 'local' ||
    env === 'hdev' ||
    env === 'qatwo' ||
    env === 'ndev' ||
    env === 'idev' ||
    env === 'sandbox'
  ) {
    return 'SANDBOXKWIKSESSIONTOKEN';
  } else if (env === 'production' || env === 'pci-prod') {
    return 'KWIKSESSIONTOKEN';
  } else if (env === 'qa' || env === 'qaone') {
    return 'QAKWIKSESSIONTOKEN';
  }
};

export const XKWIKPASSToken = () => {
  if (env === 'dev' || env === 'local' || env === 'hdev' || env === 'qatwo' || env === 'ndev' || env === 'idev') {
    return 'DEVKWIKPASSTOKEN';
  } else if (env === 'production' || env === 'pci-prod') {
    return 'KWIKPASSTOKEN';
  } else if (env === 'sandbox') {
    return 'SANDBOXKWIKPASSTOKEN';
  } else if (env === 'qa' || env === 'qaone') {
    return 'QAKWIKPASSTOKEN';
  }
};

const setCart = () => {
  store_cartjsObject.set({
    token: 'Z2NwLXVzLWVhc3QxOjAxSlY2Wks5OVhOVFdDREo1UzVXTjIyUzdW?key=5b5fa344a20624d78605e03fb418bd3a',
    note: '',
    attributes: { Gokwik: 'Checkout', 'GoKwik-Cart': true },
    original_total_price: 0,
    total_price: 0,
    total_discount: 0,
    total_weight: 0.0,
    item_count: 1,
    items: [
      {
        id: 44977066279100,
        properties: {},
        quantity: 1,
        variant_id: 44977066279100,
        key: '44977066279100:a8b0dcbe6156629bc966798f991ae722',
        title: '5 Pocket Jean final very good jeans - 34 / Indigo - Medium / Black',
        price: 0,
        original_price: 0,
        presentment_price: 0.0,
        discounted_price: 0,
        line_price: 0,
        original_line_price: 0,
        total_discount: 0,
        discounts: [],
        sku: null,
        grams: 0,
        vendor: 'gokwikproduction',
        taxable: true,
        product_id: 8885406597308,
        product_has_only_default_variant: false,
        gift_card: false,
        final_price: 0,
        final_line_price: 0,
        url: '/products/%F0%9F%8E%81-5-pocket-jean-final-very-good-jeans-34-indigo?variant=44977066279100',
        featured_image: {
          aspect_ratio: 0.714,
          alt: '5 Pocket Jean final very good jeans - 34 / Indigo',
          height: 2048,
          url: 'https://cdn.shopify.com/s/files/1/0587/1370/2588/files/2015-04-03_Jake_Look_08_32020_18028_50bd23bc-c4ba-4d0a-bad1-efd96eb4a35a.jpg?v=1749554942',
          width: 1462,
        },
        image:
          'https://cdn.shopify.com/s/files/1/0587/1370/2588/files/2015-04-03_Jake_Look_08_32020_18028_50bd23bc-c4ba-4d0a-bad1-efd96eb4a35a.jpg?v=1749554942',
        handle: '\ud83c\udf81-5-pocket-jean-final-very-good-jeans-34-indigo',
        requires_shipping: true,
        product_type: '',
        product_title: '5 Pocket Jean final very good jeans - 34 / Indigo',
        product_description: null,
        variant_title: 'Medium / Black',
        variant_options: ['Medium', 'Black'],
        options_with_values: [
          { name: 'Size', value: 'Medium' },
          { name: 'Color', value: 'Black' },
        ],
        line_level_discount_allocations: [],
        line_level_total_discount: 0,
        quantity_rule: { min: 1, max: null, increment: 1 },
        has_components: false,
      },
    ],
    requires_shipping: true,
    currency: 'INR',
    items_subtotal_price: 0,
    cart_level_discount_applications: [],
    discount_codes: [],
  });
};
const setReqId = () => {
  // store_requestId.set('687a995e-5ba9-4efd-b981-f53c1b0a9a1b');
  store_requestId.set('e1b0197c-33c7-4b59-8725-7f170d97eb8f');
};
